import axios from '../utils/axios';

export default function editMailer(adminId, id, data) {
    return (
        axios.post(`/admin/${adminId}/tag-mailers/${id}/edit`, data)
    )
}
